import React from 'react'


export const Alert = ({ variant = 'primary', children, className = '', ...props }) => (
  <div className={`alert alert-${variant} ${className}`} role="alert" {...props}>
    {children}
  </div>
)
